// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderText_header__tt_qD"};